import { MantineThemeOverride } from '@mantine/core';

export type ContainerTheme = NonNullable<MantineThemeOverride['components']>['Container'];

export const Container: ContainerTheme = {
  // todo: define
};
